const authUser = localStorage.getItem("authUser");
export const userId = authUser ? JSON.parse(authUser).user_id : null;
